import { Injectable } from '@angular/core';
import { TextEditorHistoryService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-history.service';
import { AppTextService } from '@fi-shared/app-text';
import { ITextPanelButton } from '@fi-shared/fi-text-panel/simple-text-panel/text-panel-base';

@Injectable()
export class AdvancedTextPanelHistoryService {
    constructor(
        private appTextService: AppTextService,
        private textEditorHistoryService: TextEditorHistoryService,
    ) {}

    getButtons(): ITextPanelButton[] {
        return [
            {
                title: this.appTextService.get('common.undo'),
                class: 'fas fa-undo',
                btnClass: 'BrandedColorHover panel-icon-button',
                callback: () => this.textEditorHistoryService.undo(),
            },
            {
                title: this.appTextService.get('text_editor.redo'),
                class: 'fas fa-redo',
                btnClass: 'BrandedColorHover panel-icon-button',
                callback: () => this.textEditorHistoryService.redo(),
            },
        ];
    }
}
